<template>
  <div
    id="app"
    :class="classes"
  >
    <v-app>
      <!-- Header -->
      <v-toolbar flat style="background-color: #e6e6e6" v-if="!$route.meta.replaceHeader" app>
        <v-toolbar-title>
          {{this.$route.meta.displayName}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-circular color="#4485ed" indeterminate v-if="loadingRequests || loadingFiles"/>
      </v-toolbar>

      <v-navigation-drawer
        v-if="showHeader"
        fixed
        app
        style="background-color:#2E313A"
        mini-variant
      >
      <v-layout justify-center align-center style="height:64px; background-color: #4485ed" row>
        <v-avatar>
          <v-icon>folder</v-icon>
        </v-avatar>
      </v-layout>
        <global-navigation-toolbar />
      </v-navigation-drawer>

      <v-content>
        <v-container class="pa-0 ma-0"  fill-height fluid>
          <router-view></router-view>
        </v-container>
      </v-content>

    </v-app>

    <idle-dialog ref="idleDialog" />

    <!-- Toast -->
    <v-snackbar
      :color="snackbarType"
      :timeout="3500"
      v-model="showSnackbar"
    >
      <v-icon
        v-if="snackbarType == 'success'"
        class="mr-3"
        color="white"
      >check</v-icon>
      <v-icon
        v-else
        class="mr-3"
        color="white"
      >warning</v-icon>
      <div>{{ snackbarText }}</div>
      <v-spacer></v-spacer>
    </v-snackbar>
  </div>
</template>

<script>
import DesktopFooter from '@/core/components/Footer'
import Backdrop from '@/core/components/Backdrop'
import DesktopHeader from '@/components/headers/DesktopHeader'
import MobileHeader from '@/components/headers/MobileHeader'
import { mapState, mapActions } from 'vuex'
import bus from '@/core/helpers/bus'
import Idle from '@/core/helpers/idle'
import ApplicationHeader from '@/components/headers/ApplicationHeader'
import GlobalNavigationToolbar from '@/components/headers/GlobalNavigationToolbar'
import IdleDialog from '@/components/dialogs/IdleDialog'
import RequestLogs from '@/components/RequestLogs'

export default {
  name: 'app',
  components: {
    IdleDialog,
    DesktopHeader,
    MobileHeader,
    DesktopFooter,
    Backdrop,
    ApplicationHeader,
    GlobalNavigationToolbar,
    RequestLogs
  },
  data() {
    return {
      drawer: true,
      newLayout: false,
      // loading dialog trigger
      appLoading: false,
      pageLoading: false,
      // Toast properties
      date: null,
      showSnackbar: false,
      snackbarType: '',
      snackbarText: '',
      drawerItems: [
        { title: 'Patients', icon: 'face', method: 'right-drawer-navPatient' },
        { title: 'Logout', icon: 'exit_to_app', method: 'right-drawer-logout' }
      ],
      pending: {},
      executeShowIdleDialog: null,
      lastActiveTime: null,
      idleAway: null,
      activeTimeInterval: null
    }
  },
  computed: {
    ...mapState('auth', ['user', 'brandingPartner']),
    ...mapState('admin', ['loadingRequests', 'loadingFiles']),
    ...mapState('patient', ['patient']),
    isDesktop() {
      return this.$vuetify.breakpoint.smAndUp
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    showHeader() {
      return this.$route.meta.hideHeader !== true
    },
    centerContentVertically() {
      if (this.$route.name === 'NewPatientPage') {
        return true
      } else {
        return false
      }
    },
    sizingClass() {
      if (this.newLayout) {
        return 'xs12'
      } else {
        return 'xs12 sm8'
      }
    },
    classes() {
      let classes = []
      if (this.$vuetify.breakpoint.smAndDown) {
        classes.push('device--mobile')
      } else {
        classes.push('device--desktop')
      }
      classes.push('default-branding')
      return classes.join(', ')
    }
  },
  watch: {
  },
  methods: {
    ...mapActions('auth', ['getUser', 'signOut', 'setBranding']),
    toggleDrawer() {
      if (this.drawer) {
        this.drawer = false
      } else {
        this.drawer = true
      }
    },
    logout() {
      this.pending = null
      this.signOut()
      this.$router.push('/login')
    },
    toast(text, type) {
      this.showSnackbar = true
      this.snackbarType = type
      this.snackbarText = text
    },
    navPatients() {
      this.$router.push({
        name: 'PatientsPage'
      })
    },
    showIdleDialog() {
      if (this.user) {
        this.$refs.idleDialog.open({
          persistent: true,
          ok: this.logout
        })
      }
    },
    setUnloadTimestamp() {
      // Store
      sessionStorage.setItem('unload', new Date().getTime() / 1000)
      // Retrieve
    },
    parseURLParameters() {
      const search = this.$route.query
      if (search.partner) {
        let partner = {}
        partner.id = search.partner
        partner.accessCode = search.accessCode
        this.setPartner(partner)
        this.partnerID = search.partner
        this.partnerAccessCode = search.accessCode
      }
    },
    setBrandingColors(id) {
      if (id === '5a4fa82c8e4b74e028665d04') {
        this.$vuetify.theme.primary = '#8AC340'
        this.$vuetify.theme.contrast = '#FFFFFF'
        this.$vuetify.theme.headerColor = '#666666'
      } else if (id === '5acb94000495d7065c909bc2') {
        this.$vuetify.theme.contrast = '#BDBDBD'
      } else if (id === '5b73507c4aef2028740f662b') {
        this.$vuetify.theme.primary = '#E59A1C'
        this.$vuetify.theme.contrast = '#BDBDBD'
        this.$vuetify.theme.headerColor = '#505050'
      } else if (id === '5a3f56ec92808ba8d3d5a391') {
        this.$vuetify.theme.primary = '#00B4BE'
        this.$vuetify.theme.contrast = '#BDBDBD'
      } else if (id === 'legaldemo') {
        this.$vuetify.theme.primary = '#10499C'
        this.$vuetify.theme.contrast = '#FFFFFF'
        this.$vuetify.theme.headerColor = '#96B7E7'
      }
    },
    checkFocus() {
      const fiveMinuteTimeout = 1000 * 60 * 5 // 5 minutes

      // If the user isn't on the page, set a timeout to logout in five minutes
      if (!document.hasFocus()) {
        this.idleAway = setTimeout(() => {
          this.logout()
        }, fiveMinuteTimeout)
      } else {
        if (new Date() - this.lastActiveTime > fiveMinuteTimeout) {
          this.logout()
        }
        clearTimeout(this.idleAway)
      }
    }
  },
  created() {
    window.addEventListener('beforeunload', this.setUnloadTimestamp)
    let partner = {}
    const search = this.$route.query
    if (search.partner) {
      partner.id = search.partner
    } else {
      partner.id = this.$subdomainPartner
    }

    this.setBranding({ id: partner.id })
    this.setBrandingColors(partner.id)

    // Event listeners to see if the user is away from the page
    window.addEventListener('focus', this.checkFocus)
    window.addEventListener('visibilityChange', this.checkFocus)
    window.addEventListener('blur', this.checkFocus)

    // Initialize the active tracking interval
    this.lastActiveTime = new Date()
    this.activeTimeInterval = setInterval(() => {
      this.lastActiveTime = new Date()
    }, 5000) // 5 seconds

    let offset = 10000 // 10 seconds (This is so the onAway state isn't being fired more than every 10 seconds)
    let timeout = 1000 * 60 * 4 - offset // 4 minutes - offset

    let idle = new Idle({
      onAway: () => {
        this.executeShowIdleDialog = setTimeout(() => {
          this.showIdleDialog()
        }, timeout)

        // Clear interval while the user is inactive
        clearInterval(this.activeTimeInterval)
      },
      onAwayBack: () => {
        clearTimeout(this.executeShowIdleDialog)
        clearTimeout(this.idleAway)
        this.lastActiveTime = new Date()

        // Interval to track when the user was last active, for mobile tracking mostly
        this.activeTimeInterval = setInterval(() => {
          this.lastActiveTime = new Date()
        }, 5000) // 5 seconds
      }
    })
    idle.setAwayTimeout(offset) // 10 seconds
  },
  mounted() {
    this.lastActiveTime = new Date()

    if (localStorage.getItem('newLayout')) {
      this.newLayout = true
    }

    bus.$on('toast', data => {
      this.toast(data.text, data.type)
    })
    bus.$on('toggleNewLayout', () => {
      this.newLayout = !this.newLayout
      localStorage.setItem('newLayout', true)
    })
    bus.$on('right-drawer-logout', () => {
      this.logout()
      bus.$emit('closeLeftDrawer')
    })
    bus.$on('right-drawer-navPatient', () => {
      this.navPatients()
      bus.$emit('closeLeftDrawer')
    })
    bus.$on('startLoading', () => {
      this.appLoading = false
    })
    bus.$on('stopLoading', () => {
      this.appLoading = false
      this.pageLoading = false
    })
    bus.$on('startPageLoading', () => {
      this.pageLoading = false
      this.appLoading = false
    })
    bus.$on('stopPageLoading', () => {
      this.pageLoading = false
    })
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'auth/setAuthToken':
          this.getUser()
          break
        case 'patient/setPatient':
          break
      }
    })

    // If the directed page is upload file page, does not redirect to login page
    if (sessionStorage.getItem('login')) {
      if (sessionStorage.getItem('unload')) {
        // The user is returning from a reload event or from navigating away
        if (
          new Date().getTime() / 1000 - sessionStorage.getItem('unload') >
          1000 * 60 * 4
        ) {
          // it has been longer than 4 minutes, prompt a login
          this.signOut()
          this.$router.push('/login')
        } else {
          // it has been less than 4 minutes, do nothing
        }
      }
    } else {
      // there is no record of a login within this session, prompt to log in again
      this.signOut()
      // this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700,900');
* {
  --primary-color: #ffffff3d;
}

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.grayAlternate {
  background-color: #ffffff;
}
.whiteAlternate {
  background-color: #fafafc;
}

.fade-in {
  opacity: 0; /* make things invisible upon start */
  -webkit-animation: fadeIn ease-in 1; /* call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time */
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards; /* this makes sure that after animation is done we remain at the last keyframe value (opacity: 1)*/
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 0.3s;
  -moz-animation-duration: 0.3s;
  animation-duration: 0.3s;
}

.fade-in.one {
  -webkit-animation-delay: 0.3s;
  -moz-animation-delay: 0.1s;
  animation-delay: 0.1s;
}

.fade-in.two {
  -webkit-animation-delay: 0.3s;
  -moz-animation-delay: 0.3s;
  animation-delay: 0.3s;
}

.fade-in.three {
  -webkit-animation-delay: 0.9s;
  -moz-animation-delay: 0.9s;
  animation-delay: 0.9s;
}

.fade-in.oneLong {
  -webkit-animation-delay: 0.9s;
  -moz-animation-delay: 0.9s;
  animation-delay: 0.9s;
}

.fade-in.twoLong {
  -webkit-animation-delay: 1.8s;
  -moz-animation-delay: 1.8s;
  animation-delay: 1.8s;
}

.fade-in.threeLong {
  -webkit-animation-delay: 2.7s;
  -moz-animation-delay: 2.7s;
  animation-delay: 2.7s;
}

.fade-in.fourLong {
  -webkit-animation-delay: 3.6s;
  -moz-animation-delay: 3.6s;
  animation-delay: 3.6s;
}

.fade-in.fiveLong {
  -webkit-animation-delay: 4.5s;
  -moz-animation-delay: 4.5s;
  animation-delay: 4.5s;
}

.fade-in.sixLong {
  -webkit-animation-delay: 5.4s;
  -moz-animation-delay: 5.4s;
  animation-delay: 5.4s;
}

.fade-in.slow {
  -webkit-animation-duration: 0.4s;
  -moz-animation-duration: 0.4s;
  animation-duration: 0.4s;
  -webkit-animation-delay: 0s;
  -moz-animation-delay: 0s;
  animation-delay: 0s;
}

.pageTitle {
  font-size: 36px;
  color: #222;
  font-weight: 700;
}

.pageSubtitle {
  font-size: 26px;
  color: #222;
  font-weight: 700;
}

.dialogSectionTitle {
  font-size: 18px;
  color: #222;
  font-weight: 700;
}

.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

body {
  margin: 0;
}

#app {
  font-family: 'Open Sans', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: white;
}

.default-branding {
  @import 'src/styles/default.scss';
}

.smartchoice-branding {
  @import 'src/styles/5a4fa82c8e4b74e028665d04.scss';
}

.grayhawk-branding {
  @import 'src/styles/5acb94000495d7065c909bc2.scss';
}
.imagineMD-branding {
  @import 'src/styles/12345678.scss';
}

.generic-partner-branding {
  @import 'src/styles/genericPartner.scss';
}

.u-posRelative {
  z-index: 10 !important;
}

.device--mobile .mobile--hide {
  display: none !important;
}

.device--desktop .desktop--hide {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue